import { BreadcrumbProps } from '../../components/Breadcrumb'
import { SBreadcrumb } from '../../rest/types/api/Breadcrumb'
import Router from '../../routes/Router'
import routes from '../../routes/definitions'

export function BreadcrumbTransformer(
  data?: SBreadcrumb[] | null,
  t?: any
): BreadcrumbProps | undefined {
  return data
    ? {
        items: [
          {
            text: t('home_breadcrumb_label'),
            href: t('home_breadcrumb_centrale_page_link'),
          },
          ...data.map((item) => ({
            text: item?.name ?? '',
            href: item?.slug
              ? Router.getRouteUrl(routes.category, { slug: item.slug })
              : undefined,
          })),
        ],
      }
    : undefined
}
